// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nmR4","footer":"styles_footer__fQqhX"};